import React from "react"
import { Shield, BarChart3, Navigation } from "lucide-react"
import { FeatureItem } from "./types"

export const REGIONS = [
  "Nairobi", "Central", "Rift Valley", "Nyanza",
  "Western", "Coast", "Eastern", "North Eastern",
]

export const FARM_SIZES = [
  "Below 1 acre", "1–2 acres", "2–5 acres",
  "5–10 acres", "10–20 acres", "Above 20 acres",
]

export const ARABLE_SIZES = [
  "Below 0.5 acres", "0.5–1 acre", "1–3 acres",
  "3–7 acres", "7–15 acres", "Above 15 acres",
]

export const TREE_COVERAGE = [
  "Below 0.25 acres", "0.25–0.5 acres", "0.5–1 acre",
  "1–2 acres", "2–5 acres", "Above 5 acres",
]

export const FEATURES: FeatureItem[] = [
  {
    icon: React.createElement(Shield, { className: "w-6 h-6" }),
    title: "Secure Data",
    body: "Every farmer record is securely stored and protected with enterprise-grade encryption across our infrastructure.",
    img: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=600&q=80",
    alt: "Secure farming data",
  },
  {
    icon: React.createElement(BarChart3, { className: "w-6 h-6" }),
    title: "Real-time Reporting",
    body: "Administrators get instant access to tree counts, regional distributions, and farmer analytics on a live dashboard.",
    img: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&q=80",
    alt: "Tree analytics dashboard",
  },
  {
    icon: React.createElement(Navigation, { className: "w-6 h-6" }),
    title: "GPS Farm Mapping",
    body: "Capture the exact location of every shamba. Walk the boundary to map your entire farm on an interactive satellite map.",
    img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&q=80",
    alt: "Farm GPS mapping",
  },
]

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Fill the form",
    body: "Enter your name, region, phone and farm details. Takes less than 3 minutes to complete.",
  },
  {
    n: "02",
    title: "Add your trees",
    body: "Select the types of trees on your farm and enter how many you have of each type.",
  },
  {
    n: "03",
    title: "Pin your location",
    body: "Use GPS to capture your farm's exact coordinates or walk the boundary to map your shamba.",
  },
]

export const STATS = [
  ["0", "Farmers"],
  ["0", "Trees"],
  ["0", "Regions"],
] as const